import { ArrowBackIcon } from "@chakra-ui/icons";
import { Button, HStack, IconButton, Tooltip } from "@chakra-ui/react";
import { AiFillPrinter } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import "../../styles/printing.css";

export function PrintControls({ showPrintButton = true }: { showPrintButton?: boolean }) {
  const navigate = useNavigate();

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="controls">
      <HStack className="controls" gap={2} justifyContent={"space-between"}>
        <Tooltip label="Go Back" aria-label="Go Back">
          <IconButton aria-label="Go Back" icon={<ArrowBackIcon />} onClick={handleBack} />
        </Tooltip>
        {showPrintButton && (
          <Button onClick={handlePrint} leftIcon={<AiFillPrinter />}>
            Print this page
          </Button>
        )}
      </HStack>
    </div>
  );
}
